import * as React from "react";
import { ProductTile } from "@arctheme-components/ecommerce/Product/ProductTile";

export function HeaderSearchNoResults({ settings, query }) {
  return (
    <div className="header-search-no-results">
      <p className="font-medium">
        Search Results ( 0 )
      </p>

      <div className="flex w-full justify-between">
        <p className="lg:text-xl font-light">
          {settings.no_results.title.replace("&#39;", "'")}{" "}
        </p>

        <div className="header-search-no-results__toggle" x-on:click="$store.global.toggleSearch()">
          <span className="sr-only">Close</span>
          <i className="icon icon-x-thin"></i>
        </div>
      </div>

      <div className="header-search-no-results__products">
        <div className="flex flex-1 lg:flex-0 gap-x-5">
          {settings.section_settings.product_list.map((product) => (
            <div className="min-w-[182px]">
              <ProductTile settings={settings} product={product} siblings={undefined} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
